import { IValidationError } from './interfaces/ValidationError';

interface IParams {
  value: string | undefined,
  length: number,
  fieldName: string,
  fieldCaption?: string,
}

const getDefaultMessage = (params: { fieldCaption?: string, length: number }) => {
  return `${ params.fieldCaption || 'Length' } must contain at least ${ params.length } characters`;
};

export const validateMinLength = (params: IParams, getMessage = getDefaultMessage): IValidationError => {
  if (params.value && params.value.trim().length < params.length) {
    return {
      [params.fieldName]: getMessage({
        fieldCaption: params.fieldCaption,
        length: params.length,
      }),
    };
  }
  // @ts-ignore
  return null;
};
